const browserPreferredLanguage = navigator.language;
export const inputDatetimeFormatOptions = {
    dateStyle: 'short',
    timeStyle: 'short',
};
export const outputDateFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
};
export const outputDatetimeFormatOptions = {
    ...outputDateFormatOptions,
    hour: '2-digit',
    minute: '2-digit',
    // Force a 24h clock so the output matches the date picker (date-fns `HH:mm`)
    // regardless of the locale's default clock (e.g. en-US would be 12h).
    hour12: false,
};
/**
 * Type guard for a usable `Date`.
 *
 * Returns `false` for non-`Date` values and for an "Invalid Date" (e.g.
 * `new Date('not a date')`), whose `getTime()` is `NaN`. An Invalid Date must
 * never reach consumers: `Intl.DateTimeFormat.format()` throws "date value is
 * not finite in DateTimeFormat.format()", which crashes formatters and cell
 * renderers.
 */
export const isValidDate = (value) => value instanceof Date && !Number.isNaN(value.getTime());
export function formatDate(date, options = outputDateFormatOptions) {
    if (date === null || date === undefined) {
        return undefined;
    }
    const parsed = new Date(date);
    if (!isValidDate(parsed)) {
        return undefined;
    }
    return new Intl.DateTimeFormat(browserPreferredLanguage, options).format(parsed);
}
export function formatDatetime(date, options = outputDatetimeFormatOptions) {
    return formatDate(date, options);
}
//# sourceMappingURL=date-format.js.map